// Colunas do layout Painel que a pessoa pode esconder.
//
// O cabeçalho (TicketsManager) e a linha (TicketListItem) leem daqui a mesma
// classe de largura. Antes ela estava escrita nos dois arquivos, byte a byte,
// com um comentário pedindo para não esquecer de mudar nos dois — pedido que
// alguém uma hora esquece.
//
// Aparecer depende da largura da COLUNA da lista (`@container` em
// pages/Tickets), não da janela: numa janela de 1280px a coluna do Painel
// tem ~600px e as colunas de janela larga nunca apareciam.
// `curto` é o título do cabeçalho, que tem a largura da coluna.
//
// Espera e Contato não entram: são a identidade da linha. Sem elas não sobra
// linha nenhuma para configurar.
export const COLUNAS_PAINEL = [
	{
		id: "ultimaMensagem",
		rotulo: "Última mensagem",
		dica: "O começo da última mensagem trocada.",
		curto: "Mensagem",
		classe: "hidden min-w-0 flex-[2] truncate @[28rem]:block",
	},
	{
		id: "fila",
		rotulo: "Departamento",
		dica: "O departamento do atendimento.",
		classe: "hidden w-20 shrink-0 truncate @[36rem]:block",
	},
	{
		id: "atendente",
		rotulo: "Atendente",
		dica: "Quem está cuidando do atendimento agora.",
		classe: "hidden w-20 shrink-0 truncate @[36rem]:block",
	},
	{
		id: "motivoEncerramento",
		rotulo: "Motivo do encerramento",
		dica: "Nos resolvidos, o motivo escolhido ao encerrar.",
		curto: "Motivo",
		classe: "hidden w-32 shrink-0 truncate @[48rem]:block",
	},
];

// Ids acrescentados depois que esta preferência já existia. Ver `comNovos` em services/prefsTickets.js.
export const COLUNAS_NOVAS = ["motivoEncerramento"];

export const IDS_COLUNAS_PAINEL = COLUNAS_PAINEL.map((c) => c.id);

export const classeDaColuna = (id) =>
	COLUNAS_PAINEL.find((c) => c.id === id)?.classe || "";
